<template>
  <div class="playphone-last-step-login inline-input">
    <h1 v-t.preserve="'auth.playphoneLastStep.title'" />
    <h2 v-t.preserve="'auth.playphoneLastStep.subtitle'" />

    <form class="input-container" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input v-model="email" :placeholder="$t('auth.playphoneLastStep.placeholder.email')" type="email" :error="errorCode || $v.$error" inline />
      <btn flat :loading="loading" submit>{{ $t('auth.playphoneLastStep.signIn') }}</btn>
      <div class="info">
        <error-text :active="errorCode || $v.$error" :text="errorCode ? this.$t('auth.playphoneLastStep.error.generic') : this.$t('auth.playphoneLastStep.error.email')" />
        <p class="link">
          {{ $t('auth.playphoneLastStep.forgotUserId.message') }}
          <a href="https://lootgames.co/l/sprint/playkids/pages/recovery.html" target="_blank" v-t.preserve="'auth.playphoneLastStep.forgotUserId.CTA'"/>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { AuthenticationPlatform } from '@/api/peanutbutter'
import signInService from '@/js/AuthenticationService'
import formSubmit from '@/js/mixins/formSubmit'

export default {
  name: 'playphone-last-step-login',
  mixins: [formSubmit('login')],
  data: () => ({
    email: ''
  }),
  validations: {
    email: { required, email }
  },
  methods: {
    async login() {
      await signInService.signIn({
        signInParameters: {
          authenticationPlatform: AuthenticationPlatform.PLAYPHONE,
          credentials: { email: this.email }
        }
      })

      this.$emit('authenticated')
    }
  },
  async created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }
  }
}
</script>
